const React = require('react');
const ReactIntl = require('react-intl');
const _ = require('lodash');

const { Button, Layout, Modal, ModalContent, Heading } = require('@metro-ui/core');

const defaultMessages = require('../../i18n/messages/default');

const { injectIntl } = ReactIntl;

class DeleteAuthMethodsDialogModal extends React.Component {

    render() {
        const { credentialId, userId, intl } = this.props;
        return (
            <Modal isOpen aria-labelledby="modal-title">
                <ModalContent padding="xx-large" direction="column" spacing="medium">
                    <Heading hasNoNativeMargin align="center" id="modal-title">
                        {intl.formatMessage(defaultMessages['confirm.delete'])}
                    </Heading>
                    <Layout grow={0} justify="center">
                        <Button isWide
                            size='medium'
                            className="form-controls"
                            isFullWidth={false}
                            variant='primary'
                            onClick={() => { this.props.deleteAuthenticationMethod(credentialId, userId); this.props.closeModal() }}>
                            {intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.confirm_yes'])}
                        </Button>
                    </Layout>
                    <Layout grow={0} justify="center">
                        <Button isWide
                            size='medium'
                            className="form-controls"
                            isFullWidth={false}
                            variant='outline'
                            onClick={this.props.closeModal}>
                            {intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.confirm_no'])}
                        </Button>
                    </Layout>
                </ModalContent>
            </Modal>
        );
    }
}

module.exports = injectIntl(DeleteAuthMethodsDialogModal);